import classNames from "classnames";

import Select from "rivals/components/shared/Form/Select";
import { getSites } from "rivals/redux/rails/actions";
import { getSubscribableSites } from "rivals/redux/rails/selectors";
import { useAppDispatch, useAppSelector } from "rivals/shared/utils/hooks";
import styles from "./SiteSelect.module.scss";
import type { Props } from "./types";

const SiteSelect = ({
  className,
  placeholder,
  onChange,
  onClear
}: Props): JSX.Element => {
  const dispatch = useAppDispatch();
  const sites = useAppSelector(getSubscribableSites) || [];

  const selectOptions = sites
    ? sites.map(site => ({ name: site.friendlyName, value: site.id }))
    : [];

  const setSubscription = (id: number): void => {
    const site = sites.find(site => site.id === id);
    if (!site) {
      return;
    }
    onChange(site);
  };

  const onOpen = (open: boolean): void => {
    if (open && !sites.length) {
      dispatch(getSites());
    }
  };

  return (
    <div className={classNames(styles.siteSelectContainer, className)}>
      <Select<number>
        allowClear={true} // allow clear icon shown when an option is populated in the dropdown
        data="subscriptions-site-selection"
        onChange={setSubscription}
        onClear={onClear}
        onOpen={onOpen}
        options={selectOptions}
        placeholder={placeholder}
        showSearch={true} // enable search
      />
    </div>
  );
};

export default SiteSelect;
